const SectionComposition = (props) => {
  return (
    <div className={`normal-white py-4 text-justify ${props.bgColor}`}>
        {props.children}
    </div>
  )
}

export default SectionComposition